// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3057":"24ded62a","3922":"2b395c1a","5077":"f95a378e","5332":"dd02048e"}[chunkId] + ".chunk.css";
};